// Use the current page's origin; keep host empty to avoid double slashes.
export const host = ''
export const apiBaseURL = `${host}/api`
export const uploadURL = `${apiBaseURL}/upload`
